import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { TOOLTIP_VARIANTS } from "./tooltip";

export enum TOOLTIP_PLACEMENTS {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right',
}

export interface ITooltipBoxProps {
    placement?: TOOLTIP_PLACEMENTS,
    variant?: TOOLTIP_VARIANTS,
    refElement: HTMLSpanElement|null,
    content: React.ReactNode,   
    showOnClick?: boolean,   
    clickHandler: () => void,
}

interface TooltipPosition {
    x: number;
    y: number;
    isCalculated: boolean;
}

export const TootltipBox: React.FC<ITooltipBoxProps> = ({placement = TOOLTIP_PLACEMENTS.TOP, variant, refElement, content, showOnClick, clickHandler}) => {
    const parentElement = document.body;

    const [position, setPosition] = useState<TooltipPosition>({
        x: 0,
        y: 0,
        isCalculated: false
    });

    useEffect(() => {
        const getTooltipPosition = () => {
            const rect = refElement?.getBoundingClientRect()
            var x = 0;
            var y = 0;
    
            if (rect) {
                switch (placement) {
                    case TOOLTIP_PLACEMENTS.TOP:
                        x = rect.x + rect.width / 2 + window.scrollX;
                        y = rect.y + window.scrollY;
                        break;
                    case TOOLTIP_PLACEMENTS.BOTTOM:
                        x = rect.x + rect.width / 2 + window.scrollX;
                        y = rect.y + rect.height + window.scrollY;
                        break;
                    case TOOLTIP_PLACEMENTS.LEFT:
                        x = rect.x + window.scrollX;
                        y = rect.y + rect.height / 2 + window.scrollY;
                        break;
                    case TOOLTIP_PLACEMENTS.RIGHT:
                        x = rect.x + rect.width + window.scrollX;
                        y = rect.y + rect.height / 2 + window.scrollY;
                        break;            
                }
        
                setPosition({x, y, isCalculated: true});
            }
        }

        if (refElement) {
            getTooltipPosition();
        }
    }, [placement, refElement]);

    // isCalculated is used to prevent rendering the tooltip before we have calculated its position,
    // which would cause it to flash briefly at coordinates (0,0) before moving to the correct position
    if (!position.isCalculated) {
        return null;
    }

    return createPortal(
        (
            <>
                <div className={`tooltip-overlay ${showOnClick ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); clickHandler() }}></div>
                <div 
                    className={`tooltip place-${placement} ${variant}`} 
                    style={ { left: position.x, top: position.y } }
                    onClick={(e) => e.stopPropagation()}
                >
                    {content}
                </div>
            </>
        ),
        parentElement
    );
}